<!--@name: 班组找活搜索-->
<template>
  <div :style="{ paddingTop: top ? '10px' : 0 }">
    <ScreenSort
      @changeobj="changeobj"
      :config="['secondCategory', 'locationAddress']"
      :secondCategoryi="3"
      :getquery="true"
      ref="ScreenSort"
    ></ScreenSort>
    <!-- 排序按钮组 -->
    <SortBtn :update="update" :isShowDistance="false"></SortBtn>
    <div class="table" v-loading="loading">
      <div style="padding: 0 20px 10px 20px">
        <el-row :gutter="20" v-if="list.length">
          <el-col v-for="(item, index) in list" :span="12" :key="index">
            <card :item="item" :type="7" :index="index" :showIndex="false"></card>
          </el-col>
          <template>
            <el-col :span="24" class="course-loading-wrap" v-show="moreLoading">
              数据加载中... <i class="el-icon-loading loading-icon"></i>
            </el-col>
            <el-col :span="24" class="course-loading-wrap" v-show="!moreLoading && nomore">没有更多数据了!</el-col>
          </template>
        </el-row>

        <div
          v-if="!list.length && !loading"
          style="width: 1200px; margin: 0 auto; margin-bottom: 10px"
        >
          <BaseEmptyData></BaseEmptyData>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiTeamSearchJob } from "@/api/apiTeamSearchJob"
const throttle = require("lodash/throttle");
import SortBtn from "@/components/sortBtnGroup/SortBtn"
export default {
  name: "team",
  components: {
    ScreenSort: () => import("@/components/screenSort/screenSort"),
    Pagination: () => import("@/components/card/page"),
    card: () => import("@/components/card/cardTeamSearchJob.vue"),
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"),
    SortBtn
  },
  props: {
    top: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      teamType:'',
      moreLoading: false, //加载更多
      nomore: false, //没有数据显示
      loading: true,
      list: [],
      params: {},
      param: {
        page: 1,
        limit: 40,
        total: 0,
        totalPages: 0,
      },
      upadta:true
    }
  },
  watch: {
    // 页数改变的时候
    "param.page": {
      handler(val) {
        if (val > this.param.totalPages) {
          this.nomore = true;
        } else {
          this.nomore = false;
        }
      },
    },
  },
  methods: {
    getlist() {
      this.moreLoading = true //加载更多显示
      let params = { ...this.params }
      params.current = this.param.page
      params.limit = this.param.limit
      params.sortType = this.param.sortType
      apiTeamSearchJob
        .GetTeamsearchjobList(params)
        .then(res => {
          if (res && res.data.code == 200) {
            this.param.total = res.data.data.total
            this.list = [...this.list,...res.data.data.records]
            this.param.totalPages=res.data.data.pages;
            this.moreLoading = false //加载更多隐藏
            this.$parent.count6 = res.data.data.total
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
     // 页面滚动
    windowScroll: throttle(
      function () {
        // 如果当前页数大于总页数 则不去获取
        let scrollTop =
          document.documentElement.scrollTop ||
          window.pageYOffset ||
          document.body.scrollTop;
        let scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight;
        let clientHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
        /**
         * clientHeight 视口大小
         * scrollHeight 文档高度
         */
        if (scrollTop + clientHeight >= scrollHeight - 300) {
          this.param.page += 1;
          if (this.param.page <= this.param.totalPages) {
            this.getlist()
          }
        }
      },
      1500,
      { leading: false, trailing: true }
    ),
    changeobj(obj) {
      this.param.page=1
      this.list = []
      this.loadingTrue = true
      for(let i in this.params){
        this.params[i]=''
      }
      this.params.firstCategoryNo=this.$store.state.firstCategoryNo ? this.$store.state.firstCategoryNo :'';
      let t=this;
      ['firstCategoryNo','secondCategoryNo','thirdCategoryNo','fourCategoryNo','fifthCategoryNo','sixthCategoryNo'].forEach((v,i)=>{
        if(obj.secondCategory){
          t.params[v]=obj.secondCategory[i]?obj.secondCategory[i].no:''
        }else{
          t.params[v]=''
          t.params.firstCategoryNo=this.$store.state.firstCategoryNo ? this.$store.state.firstCategoryNo :''
        }
      })
      this.params.provinceNo=obj.locationAddresscode.provinceId;
      this.params.cityNo=obj.locationAddress?obj.locationAddresscode.cityId:'';
      this.params.areaNoList=obj.locationAddress?obj.locationAddress.map(v=>{return v.no}):[];
      if(obj.locationAddresscode.isAll){
        this.params.areaNoList=this.params.areaNoList[0]
      }
      //获取搜索值
      this.params.keyWord = localStorage.getItem("search_query")
      this.getlist();
    },
    getList() {
      this.param.page = 1
      this.list = []
      this.loading = true
      this.getlist()
    }
  },
  mounted(){
    document.addEventListener("scroll", this.windowScroll);
  },
   beforeDestroy() {
    document.removeEventListener("scroll", this.windowScroll);
  },
  provide() {
    return {
      cardListCom: this
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  position: relative;
  width: 1198px;
  margin: 0 auto;
  overflow: hidden;
  min-height: 400px;
  background: white;
  border-top: none;
  border-left: 1px solid #e4e7ed;
  border-right: 1px solid #e4e7ed;
  border-bottom: 1px solid #e4e7ed;
  /deep/ .right {
    right: 0;
  }
}
.course-loading-wrap {
    display: flex;
    padding-top: 10px;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    color: #999;
    background: #fff;
    .loading-icon {
      margin-left: 12px;
      font-size: 24px;
    }
  }
</style>